import React from "react";
import "./ScorecardSummaryRowHoleScoreCell.css"; // Import the CSS file

function ScorecardSummaryRowTotalScoreCell({
  total,
  isDnf,
  isEmptyHole,
  needsLeftBorder,
}) {
  var class_ = "";

  if (needsLeftBorder) {
    class_ = "scorecard-summary-needs-left-border";
  } else {
    class_ = "scorecard-summary-total-score-cell";
  }

  return (
    <td
      // if needsLeftBorder is true, add a left border to the cell with class scorecard-summary-needs-left-border

      className={class_}
      style={{
        background: isEmptyHole === "true" ? "#C9CBE7" : "transparent",
      }}
    >
      {isDnf ? "DNF" : total}
    </td>
  );
}

export default ScorecardSummaryRowTotalScoreCell;
